import GaugeChart from 'react-gauge-chart';
import React from 'react';
interface GaugeProps {
    title: string;
    value: number;
    maxValue: number;
  }
const Gauge3: React.FC<GaugeProps> = React.memo(({ title, value, maxValue }) => {
    const percentage = (value / maxValue);
    const getCondition = (percentage: number) => {
        if (percentage <= 0.25) return 'Normal Conditions'; // Green
        if (percentage <= 0.50) return 'Elevated Conditions'; // Yellow
        if (percentage <= 0.75) return 'Peak Conditions'; // Red
        if (percentage <= 1) return 'Critical Conditions'; // Dark Red
        return 'Normal Conditions'; // Green
    };

    const conditionColors = {
        'Normal Conditions': '#67A24B',
        'Elevated Conditions': '#F3A03D',
        'Peak Conditions': '#D8433B',
        'Critical Conditions': '#BE2E33'
    };    

    return (
        <div style={{margin: 'auto'}}>
            <h2>{title}</h2>
            <div style={{ maxWidth: '500px', margin: 'auto'}}>
                <GaugeChart id="gauge-chart1" hideText={true} percent={percentage} nrOfLevels={4} arcPadding={0.01} colors={['#67A24B', '#F3A03D', '#D8433B', '#BE2E33']} textColor='black'/>
            </div>
            <h2 style={{ marginTop:'-20px'}}>{getCondition(percentage)}</h2>
            <div style={{ marginRight:'60px', marginLeft:'60px', fontSize: '13px', color: '#333' }}>
                <ul style={{ margin:"0px", textAlign: 'left', listStyleType: 'none', paddingLeft: '0' }}>
                    <li><span style={{ color: '#67A24B', fontSize: '20px' }}>●</span> Green – Normal Conditions: System conditions are stable with adequate power supply to meet demand.</li>
                    <li><span style={{ color: '#F3A03D', fontSize: '20px' }}>●</span> Yellow – Elevated Conditions: System conditions are tightening. Partial activation of the Demand Response program may be necessary.</li>
                    <li><span style={{ color: '#D8433B', fontSize: '20px' }}>●</span> Light Red – Peak Conditions: Power demand is high, and system resources are being fully optimized. Full activation of the Demand Response program is necessary.</li>
                    <li><span style={{ color: '#BE2E33', fontSize: '20px' }}>●</span> Dark Red – Critical Conditions: The grid is under significant pressure. Extended, full-scale Demand Response measures are necessary.</li>
                </ul>
            </div>
            <footer style={{ fontSize: '10px', color: '#666', padding:'10px'}}>
                <p>This graphic represents the current state of Minnkota’s system. Conditions can change rapidly and without notice based on available power supply, demand and market pricing. Please contact your retail electric cooperative or municipal utility if you have questions or concerns.</p>
            </footer>
        </div>
        );
    });

export default Gauge3;
    